export function FlipTile() {
    document.addEventListener('DOMContentLoaded', () => {
        const tiles = document.querySelectorAll('[data-flip-tile]');
        if (!tiles.length) return;

        const hoverQuery = window.matchMedia('(hover: hover)');

        // Klik przerzuca kafelek tylko na dotyku; na desktopie flip robi :hover (CSS).
        // Stan hover sprawdzamy na żywo (hoverQuery.matches), żeby działało też po resize/zmianie trybu
        // bez przeładowania — listener jest podpięty raz, decyzja zapada w momencie kliknięcia.
        tiles.forEach((tile) => {
            tile.addEventListener('click', () => {
                if (hoverQuery.matches) return;
                tile.classList.toggle('is-active');
            });
        });

        // Po wejściu na desktop (pojawia się hover) czyścimy stan klikowy z dotyku.
        hoverQuery.addEventListener('change', (event) => {
            if (event.matches) {
                tiles.forEach((tile) => tile.classList.remove('is-active'));
            }
        });
    });
}
